import withTabs from "../../conteiners/tabs/Tabs.hoc";

const GoodsReceivingWarehouse = () => {
  return <div>GoodsReceivingWarehouse</div>;
};

export default withTabs({label: "Receiving goods at the Warehouse"})(GoodsReceivingWarehouse);
